module.exports = __webpack_public_path__ + "static/media/ma_casinoBanner.9b7c6bf4.png";